import cx from 'classnames';
import React from 'react';
import ReactTimeAgo from 'react-time-ago';
import styles from '../assets/scss/modules/_previewUI.module.scss';
import { InfoIcon } from '../components/icons/InfoIcon';
import { KEEP_PREVIEW_FOR_DAYS } from '../constants/projectConstants';
import NoDataFound from './NoDataFound';
import ThumbnailCardUI from './ThumbnailCardUI';
import { getDateLeftFromDate, getRenderStatusToHighlight, isTransparentImage } from '../helpers/jsHelper';
import { USER_PROFILE_PLACEHOLDER } from '../config/constant/assetConstant';
import { RENDER_STATUS } from '../constants/constants';
import SkeletonLoaderUI, { SkeletonUI, SKELETON_LAYOUT, SKELETON_LOADER_TYPE } from '../skeletonLoaderUI/SkeletonLoaderUI';

export default function PreviewSidebar(props) {

  const {
    theme,
    title,
    userName,
    updatedAt,
    created_at,
    cards,
    isFullscreen,
    className,
    classNameFullscreen,
    activeIndex,
    setActiveIndex,
    activeCameraId,
    setActiveCameraId,
    memberDetails,
    loading,
    isTransparentBg,
    hideAutoEraseWarning,
    disableClick,
    resetLines
  } = props;
  
  let daysLeft = KEEP_PREVIEW_FOR_DAYS;
  if(created_at){
    daysLeft = getDateLeftFromDate({ date: created_at, daysToBeAdded: KEEP_PREVIEW_FOR_DAYS });
  }

  const updateImage = (i, a) => {
    if (!disableClick) {
      if (activeCameraId !== a?.id) {
        resetLines?.();
      }
      setActiveIndex(i);
      setActiveCameraId(a?.id);
    }
  }

  return (
    <div
      className={cx(
        styles.sidebar,
        className,
        isFullscreen && styles.fullscreen,
        isFullscreen && classNameFullscreen,
        styles[theme]
      )}>
        <>
        {
          loading
          ?
          <div className="d-flex gap-3 align-items-center" style={{ padding: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid var(--neutral40-color)' }}>
            <SkeletonUI height="48px" width="48px" borderRadius="0.25rem" count={1} />
            <SkeletonUI count={2} width="125px" />
          </div>
          :
          (
            // for organisation rooms
            props?.currentOrgDetails
            &&
            <div className={styles.sidebarTop}>
              {
                props.currentOrgDetails?.thumbnail
                &&
                <img src={props.currentOrgDetails?.thumbnail} alt="Avatar" className={styles.avatar} />
              }
              
              <div className={styles.textContainer}>
                <div className={styles.textContainerTitle} title={title}>{title}</div>
                <div className={styles.editedInfo}>
                  {
                    props.currentOrgDetails?.thumbnail
                    ?
                    props.currentOrgDetails?.name
                    :
                    `Created by: ${props.currentOrgDetails?.name}`
                  }
                </div>
              </div>
            </div>
          )
          ||
          (
            // for renders/previews
            memberDetails
            &&
            <div className={styles.sidebarTop}>
              <img src={memberDetails?.profile_image || USER_PROFILE_PLACEHOLDER} alt="Avatar" className={styles.avatar} />
            
              <div className={styles.textContainer}>
                <div className={styles.textContainerTitle} title={title}>{title}</div>
                <div className={styles.editedInfo}>
                  {memberDetails?.first_name ? memberDetails?.first_name : memberDetails?.name}
                  {' · '}
                  <span className={styles.timeAgo}>
                    {updatedAt && <ReactTimeAgo date={updatedAt} />}
                  </span>
                </div>
              </div>
            </div>
          )
        }
        
        {/* End Top Block */}
        <div className={cx(`px-3 pb-3`, 
          styles.sidebarCardContainer,
          (cards?.length > 0 && cards[0]?.is_preview) && styles.notPreview
        )}>
          {
            loading
            ?
            <SkeletonLoaderUI type={SKELETON_LOADER_TYPE.SMALL_THUMBNAIL_CARD} layout={SKELETON_LAYOUT.VERTICAL} />
            :
            cards?.length > 0
            ?
            <div className="preview-image-side-section">
              {
                cards?.map((a, i) => {
                  const transparent = isTransparentImage(a?.thumbnail);

                  const tagsConfig = {
                    [RENDER_STATUS.STATUS_DISABLED]: {
                      type: 'disabled',
                      label: 'Disabled',
                    },
                    [RENDER_STATUS.STATUS_FAILED]: {
                      type: 'error',
                      label: 'Failed',
                    },
                    [RENDER_STATUS.STATUS_NOT_DONE]: {
                      type: 'pending',
                      label: 'Queued',
                    },
                    [RENDER_STATUS.STATUS_PROCESSING]: {
                      type: 'secondary',
                      label: 'Processing',
                    },
                  }

                  const tag = tagsConfig[a.status];
                  const tags = tag ? [tag] : undefined;

                  return (
                    <ThumbnailCardUI
                      key={a.id}
                      id={a.id}
                      thumbnail={a?.thumbnail}
                      className={cx(`smallThumbCard`, styles.sidebarThumbnail)}
                      name={a.name}
                      highlight={getRenderStatusToHighlight(a?.status)}
                      selected={activeCameraId === a.id}
                      imageProps={{
                        contain: true,
                        rounded: false,
                        className: isTransparentBg || transparent ? 'lf-checker-png-sm' : undefined,
                      }}
                      onClick={
                        () => {
                          updateImage(i, a)
                        }
                      }
                      tagList={tags}
                    />
                  )
                })
              }
            </div>
            :
            <NoDataFound title={'Camera Angles'} />
          }
        </div>
        {/* {
          (cards?.length > 0 && cards[0]?.is_preview) && !hideAutoEraseWarning
          &&
          <div className={styles.sidebarPreviewNote}>
            <InfoIcon/><p>Auto erase in {daysLeft} Days </p>
          </div>
        } */}
        </>
    </div>
  );
}
